$(document).foundation();

jQuery(document).ready(function($) {

  headerHandler.init();
  gfHandler.init();
  homeHandler.init();
  changingTextHandler.init();
  growingTextHandler.init();
  contactHandler.init();

  document.fonts.ready.then(function() {
    testimonialHandler.init();
    descriptionHandler.init();
    featuresHandler.init();
    teamHandler.init();
    caseStudyHandler.init();
    insightHandler.init();
    pdfHandler.init();
  });

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  /*
  var $body = $('body');

  $($body).scroll(function() {
    // selectors
    var $window = $(window),
        $panel = $('.section');
    
    // Change 33% earlier than scroll position so colour is there when you arrive.
    var scroll = $window.scrollTop() + ($window.height() / 3);
   
    $panel.each(function () {
      var $this = $(this);
      
      // if position is within range of this panel.
      // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
      // Remember we set the scroll to 33% earlier in scroll var.
      if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {
            
        // Remove all classes on body with color- 
        $body.removeClass(function (index, css) {
          return (css.match (/(^|\s)bg-color-\S+/g) || []).join(' ');
        });
         
        // Add class of currently active div
        $body.addClass('bg-color-' + $(this).data('color'));
      }
    });    
    
  }).scroll();
  */

})
